import { clientHostname, environment } from "src/environments/environment";
import { AccountType } from "./enums/account-types.enum";

export class CompanySelectResponse {
    accountType: AccountType;
    companyId: number;
    navigationRoute: string;

    constructor(companyId: number, accountType: AccountType, navigationRoute: string = null) {
        this.accountType = accountType;
        this.companyId = companyId;
        this.navigationRoute = navigationRoute === null ? this.getDefaultNavgationRoute() : navigationRoute; 
    }

    private getDefaultNavgationRoute() {
        return `${clientHostname}/trax?CompanyId=${this.companyId}&AccountType=${this.accountType}`;
    }
}